/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  DeleteApiProjectstatusesIdMutationResponse,
  DeleteApiProjectstatusesIdPathParams,
} from '../models/DeleteApiProjectstatusesId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { deleteApiProjectstatusesIdMutationResponseSchema } from '../zod/deleteApiProjectstatusesIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const deleteApiProjectstatusesIdMutationKey = () =>
  [{ url: '/api/projectstatuses/:id' }] as const;

export type DeleteApiProjectstatusesIdMutationKey = ReturnType<
  typeof deleteApiProjectstatusesIdMutationKey
>;

/**
 * {@link /api/projectstatuses/:id}
 */
export async function deleteApiProjectstatusesId(
  id: DeleteApiProjectstatusesIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectstatusesIdMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'DELETE',
    url: `/api/projectstatuses/${id}`,
    ...requestConfig,
  });
  return deleteApiProjectstatusesIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/projectstatuses/:id}
 */
export function useDeleteApiProjectstatusesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectstatusesIdMutationResponse,
      ResponseErrorConfig<Error>,
      { id: DeleteApiProjectstatusesIdPathParams['id'] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiProjectstatusesIdMutationKey();

  return useMutation<
    DeleteApiProjectstatusesIdMutationResponse,
    ResponseErrorConfig<Error>,
    { id: DeleteApiProjectstatusesIdPathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return deleteApiProjectstatusesId(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
